module.exports = __webpack_public_path__ + "img/google.409d1374.svg";